<div class="sitesList__list">
  <cdk-virtual-scroll-viewport
    sidePanelAccountsScrollerStrategyDirective
    [itemHeights]="itemHeights"
    class="cdkScroller"
    minBufferPx="1000"
    maxBufferPx="2000"
  >
    <div
      cdkDropList
      [cdkDropListData]="flattenedAccounts"
      cdkDropListOrientation="mixed"
      (cdkDropListDropped)="drop($event)"
      #sitesList
    >
      <ng-container
        *cdkVirtualFor="let item of flattenedAccounts; let index = index; trackBy: trackByFunction"
      >
        <div [attr.data-testid]="'flattenedAccounts-item-' + index">
          @switch (item.type) {
            @case (ESidePanelItem.ACCOUNT) {
              <pp-side-panel-account-row
                cdkDrag
                [cdkDragDisabled]="true"
                [ppAccount]="item"
                (ppUpdate)="updateList()"
                [attr.index]="index"
                [attr.folderId]="item.folderId"
                [attr.workspaceId]="item.workspaceId"
                [attr.accountId]="item.accountId"
              ></pp-side-panel-account-row>
            }
            @case (ESidePanelItem.END_LINE) {
              <pp-side-panel-end-line-row
                cdkDrag
                [cdkDragDisabled]="true"
                [attr.index]="index"
                [attr.folderId]="item.folderId"
                [attr.workspaceId]="item.workspaceId"
                [attr.accountId]="item.accountId"
              ></pp-side-panel-end-line-row>
            }
            @case (ESidePanelItem.FOLDER) {
              <pp-side-panel-folder-row
                cdkDrag
                [cdkDragDisabled]="true"
                [attr.index]="index"
                [attr.folderId]="item.folderId"
                [attr.workspaceId]="item.workspaceId"
                [attr.accountId]="item.accountId"
                [ppFolder]="item"
                (ppUpdate)="updateList()"
              ></pp-side-panel-folder-row>
            }
            @case (ESidePanelItem.FOLDER_EMPTY) {
              <pp-side-panel-empty-folder-message
                cdkDrag
                [cdkDragDisabled]="true"
                [attr.index]="index"
                [attr.folderId]="item.folderId"
                [attr.workspaceId]="item.workspaceId"
                [attr.accountId]="item.accountId"
              ></pp-side-panel-empty-folder-message>
            }
            @case (ESidePanelItem.WORKSPACE) {
              <pp-side-panel-workspace-row
                cdkDrag
                [ppClickable]="!dragged"
                [cdkDragDisabled]="!item.draggable || isTouchDevice"
                [cdkDragData]="item"
                [attr.index]="index"
                [attr.folderId]="item.folderId"
                [attr.workspaceId]="item.workspaceId"
                [attr.accountId]="item.accountId"
                [ppWorkspace]="item"
                (ppUpdate)="updateList()"
              ></pp-side-panel-workspace-row>
            }
            @case (ESidePanelItem.NEW_SITE_BUTTON) {
              <pp-side-panel-new-site-button
                cdkDrag
                [cdkDragDisabled]="true"
                [attr.index]="index"
                [attr.folderId]="item.folderId"
                [attr.workspaceId]="item.workspaceId"
                [attr.accountId]="item.accountId"
                [ppItem]="item"
              ></pp-side-panel-new-site-button>
            }
            @case (ESidePanelItem.FAVOURITES) {
              <pp-side-panel-favourites-row
                cdkDrag
                [cdkDragDisabled]="true"
                [attr.index]="index"
                [attr.folderId]="item.folderId"
                [attr.workspaceId]="item.workspaceId"
                [attr.accountId]="item.accountId"
                (ppUpdate)="updateList()"
              ></pp-side-panel-favourites-row>
            }
            @case (ESidePanelItem.FAVOURITES_EMPTY) {
              <pp-side-panel-favourites-empty-row
                cdkDrag
                [cdkDragDisabled]="true"
                [attr.index]="index"
                [attr.folderId]="item.folderId"
                [attr.workspaceId]="item.workspaceId"
                [attr.accountId]="item.accountId"
              ></pp-side-panel-favourites-empty-row>
            }
          }
        </div>
      </ng-container>
    </div>
  </cdk-virtual-scroll-viewport>
</div>
